// 7 columns x 6 rows keeps every month, including six-week months, at a fixed grid size.
export const DATE_BODY_CELL_COUNT = 42

const buildEmptyCell = (key) => ({
  key,
  state: null,
  label: null,
  isoDate: null,
})

/**
 * Builds the fixed 42-cell geometry for a calendar month.
 * @param {dayjs.Dayjs} monthDate - Date within the calendar month
 * @returns {Array<{ key: string, state: null, label: (number|null), isoDate: (string|null) }>}
 */
export default function calendarMonthLayout(monthDate) {
  const startOfMonth = monthDate.startOf('month')

  const leadingEmptyCells = Array.from(
    { length: startOfMonth.day() },
    (_, index) => buildEmptyCell(`empty-leading-${index}`)
  )

  const dateCells = Array.from(
    { length: startOfMonth.daysInMonth() },
    (_, index) => {
      const day = index + 1
      const date = startOfMonth.date(day)
      const isoDate = date.format('YYYY-MM-DD')

      return {
        key: isoDate,
        state: null,
        label: day,
        isoDate,
      }
    }
  )

  const cells = [...leadingEmptyCells, ...dateCells]

  const trailingEmptyCells = Array.from(
    { length: DATE_BODY_CELL_COUNT - cells.length },
    (_, index) => buildEmptyCell(`empty-trailing-${cells.length + index}`)
  )

  return [...cells, ...trailingEmptyCells]
}
